import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as StickyActionsSelectors from "@/redux/modules/value/stickyActions/stickyActions.selectors";
import {
    ScrollDirection,
    useDetectScroll
} from "@/utils/hooks/useDetectScroll";

import { BackToTopComponent } from "./backToTop.component";

const BACK_TO_TOP_VISIBLE_AT = 400;

const BackToTop = () => {
    const isStickyActionsOpen = useSelector(StickyActionsSelectors.isOpen);

    const { direction } = useDetectScroll();

    const [visible, setVisible] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const updateVisibility = () =>
            setVisible(
                () =>
                    window.scrollY > BACK_TO_TOP_VISIBLE_AT &&
                    direction !== ScrollDirection.Down
            );

        updateVisibility();
        document.addEventListener("scroll", updateVisibility);
        return () => document.removeEventListener("scroll", updateVisibility);
    }, [setVisible, direction]);

    return (
        <BackToTopComponent
            visible={visible}
            bottomControlsVisible={isStickyActionsOpen}
        />
    );
};

export { BackToTop };
